import React from "react";
import styled from "styled-components";
import PretendardText from "../pretendardText";

const DetailFormTitle = (props) => {
  return <DetailFormTitleWrapper {...props} />;
};

export default DetailFormTitle;

const DetailFormTitleWrapper = styled(PretendardText).attrs((props) => {})`
  min-width: 102px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16.71px;
  color: #aaa;
`;
